// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Theme-aware palette (2026-08-13): the Setup lenses were hardcoded to
   dark-mode whites and vanished in light mode. Component vars, dark values
   under :host-context(.dark) — matches the app's :root.dark switching. */
:host {
  --lens-fg: rgba(0, 0, 0, 0.87);
  --lens-fg-soft: rgba(0, 0, 0, 0.55);
  --lens-fg-faint: rgba(0, 0, 0, 0.38);
  --lens-hover-bg: rgba(0, 0, 0, 0.05);
  --lens-line: rgba(0, 0, 0, 0.12);
  --lens-surface: rgba(0, 0, 0, 0.025);
}

:host-context(.dark) {
  --lens-fg: rgba(255, 255, 255, 0.92);
  --lens-fg-soft: rgba(255, 255, 255, 0.55);
  --lens-fg-faint: rgba(255, 255, 255, 0.38);
  --lens-hover-bg: rgba(255, 255, 255, 0.06);
  --lens-line: rgba(255, 255, 255, 0.12);
  --lens-surface: rgba(255, 255, 255, 0.03);
}

/* Section shell — mirrors the Setup tab's .setup-item look (see credential-pool) */
.setup-item {
  border: 1px solid var(--border-color, var(--lens-line));
  border-radius: 10px;
  padding: 14px 16px;
  margin-bottom: 14px;
  background: var(--surface-color, var(--lens-surface));
}

.setup-item-header {
  display: flex;
  align-items: center;
  gap: 12px;
}
.setup-item-header .status-icon {
  opacity: 0.8;
}
.setup-item-header .setup-item-info {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.setup-item-header .setup-item-title {
  font-weight: 600;
}
.setup-item-header .setup-item-status {
  opacity: 0.65;
  font-size: 0.85em;
}
.setup-item-header .chevron {
  transition: transform 0.15s ease;
  opacity: 0.6;
}
.setup-item-header .chevron.open {
  transform: rotate(180deg);
}

.pool-groups {
  margin-top: 12px;
}

.pool-group {
  margin-bottom: 12px;
}

.pool-provider {
  font-weight: 600;
  opacity: 0.85;
  margin-bottom: 4px;
}

.pool-row {
  padding: 2px 0 2px 14px;
}

.pool-cred {
  opacity: 0.55;
  font-size: 0.85em;
  margin-left: 6px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/settings/model-pool-lens/model-pool-lens.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;yEAAA;AAGA;EACE,8BAAA;EACA,mCAAA;EACA,oCAAA;EACA,oCAAA;EACA,gCAAA;EACA,oCAAA;AAEF;;AAAA;EACE,oCAAA;EACA,yCAAA;EACA,0CAAA;EACA,0CAAA;EACA,sCAAA;EACA,yCAAA;AAGF;;AAAA,mFAAA;AACA;EACE,uDAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qDAAA;AAGF;;AAAA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAGF;AADE;EAAe,YAAA;AAIjB;AAHE;EAAmB,aAAA;EAAe,sBAAA;EAAwB,OAAA;AAQ5D;AAPE;EAAoB,gBAAA;AAUtB;AATE;EAAqB,aAAA;EAAe,iBAAA;AAatC;AAZE;EAAW,gCAAA;EAAkC,YAAA;AAgB/C;AAfE;EAAgB,yBAAA;AAkBlB;;AAfA;EAAe,gBAAA;AAmBf;;AAlBA;EAAc,mBAAA;AAsBd;;AArBA;EAAiB,gBAAA;EAAkB,aAAA;EAAe,kBAAA;AA2BlD;;AA1BA;EAAY,uBAAA;AA8BZ;;AA5BA;EAAa,aAAA;EAAe,iBAAA;EAAmB,gBAAA;AAkC/C","sourcesContent":["/* Theme-aware palette (2026-08-13): the Setup lenses were hardcoded to\n   dark-mode whites and vanished in light mode. Component vars, dark values\n   under :host-context(.dark) — matches the app's :root.dark switching. */\n:host {\n  --lens-fg: rgba(0, 0, 0, 0.87);\n  --lens-fg-soft: rgba(0, 0, 0, 0.55);\n  --lens-fg-faint: rgba(0, 0, 0, 0.38);\n  --lens-hover-bg: rgba(0, 0, 0, 0.05);\n  --lens-line: rgba(0, 0, 0, 0.12);\n  --lens-surface: rgba(0, 0, 0, 0.025);\n}\n:host-context(.dark) {\n  --lens-fg: rgba(255, 255, 255, 0.92);\n  --lens-fg-soft: rgba(255, 255, 255, 0.55);\n  --lens-fg-faint: rgba(255, 255, 255, 0.38);\n  --lens-hover-bg: rgba(255, 255, 255, 0.06);\n  --lens-line: rgba(255, 255, 255, 0.12);\n  --lens-surface: rgba(255, 255, 255, 0.03);\n}\n\n/* Section shell — mirrors the Setup tab's .setup-item look (see credential-pool) */\n.setup-item {\n  border: 1px solid var(--border-color, var(--lens-line));\n  border-radius: 10px;\n  padding: 14px 16px;\n  margin-bottom: 14px;\n  background: var(--surface-color, var(--lens-surface));\n}\n\n.setup-item-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n\n  .status-icon { opacity: 0.8; }\n  .setup-item-info { display: flex; flex-direction: column; flex: 1; }\n  .setup-item-title { font-weight: 600; }\n  .setup-item-status { opacity: 0.65; font-size: 0.85em; }\n  .chevron { transition: transform 0.15s ease; opacity: 0.6; }\n  .chevron.open { transform: rotate(180deg); }\n}\n\n.pool-groups { margin-top: 12px; }\n.pool-group { margin-bottom: 12px; }\n.pool-provider { font-weight: 600; opacity: 0.85; margin-bottom: 4px; }\n.pool-row { padding: 2px 0 2px 14px; }\n.pool-model { }\n.pool-cred { opacity: 0.55; font-size: 0.85em; margin-left: 6px; }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
